import { LocationStrategy } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { SvgComponent } from "@dentally/ui/angular/src/components/svg/svg.component";
import { SecureConnectionBannerComponent } from "@apps/patient-core/src/app/components/secure-connection-banner/secure-connection-banner.component";
import { SiteContactDetailsBannerComponent } from "@apps/patient-core/src/app/components/site-contact-details-banner/site-contact-details-banner.component";
import { ShortCodesService } from "@apps/patient-app/src/app/services/short-codes.service";
import { disableBackButton } from "@apps/patient-core/src/app/utils/disable-back-button";

@Component({
  selector: "dentr-medical-history-completed",
  templateUrl: "./medical-history-completed.component.html",
  imports: [SvgComponent, SecureConnectionBannerComponent, SiteContactDetailsBannerComponent],
  standalone: true,
})
export class MedicalHistoryCompletedComponent implements OnInit {
  constructor(private _shortCodesService: ShortCodesService, private _location: LocationStrategy) {}

  public async ngOnInit() {
    disableBackButton(this._location);

    await this._shortCodesService.actionComplete();
  }
}
